export const BRAND = "Verbulat";
export const EMAIL = "Thesmithgroup824@gmail.com";

export const mailto = (subject) =>
  `mailto:${EMAIL}?subject=${encodeURIComponent(subject)}`;

export const SAMPLE_PDF = "/verbulat-sample-before-after.pdf";
export const RUSH_PRICE = 25;

export const STEPS = [
  { n: "01", title: "You send it", text: "Email your current resume and the kind of job you want next. A job posting link helps too." },
  { n: "02", title: "We draft", text: "Every bullet is rebuilt as action verb, the task you did, and the measurable result it produced." },
  { n: "03", title: "We verify", text: "We cut anything exaggerated or invented, ask you for the real numbers, and tailor keywords to your target jobs." },
  { n: "04", title: "You get files", text: "A clean, ready-to-send Word document and PDF land in your inbox." },
];

export const VERBS = ["Led", "Reduced", "Grew", "Launched", "Negotiated", "Streamlined", "Rebuilt", "Trained", "Resolved", "Delivered"];

export const SAMPLE = {
  before: [{ t: "Responsible for handling customer complaints and helping the team with various tasks." }],
  draft: [
    { t: "Resolved", k: "verb" }, { t: " " }, { t: "[how many?]", k: "gap" },
    { t: " customer complaints weekly and cut average response time from " },
    { t: "[?]", k: "gap" }, { t: " to " }, { t: "[?]", k: "gap" },
    { t: " by introducing a shared " }, { t: "ticket queue", k: "kw" }, { t: "." },
  ],
  final: [
    { t: "Resolved", k: "verb" }, { t: " " }, { t: "40+", k: "num" },
    { t: " customer complaints weekly and cut average response time from " },
    { t: "2 days", k: "num" }, { t: " to " }, { t: "6 hours", k: "num" },
    { t: " by introducing a shared " }, { t: "ticket queue", k: "kw" }, { t: "." },
  ],
};

export const TIERS = [
  {
    id: "single", lookup: "single_role", name: "Single Role", price: 75, blurb: "Sharpen the one job that matters most.",
    items: ["Bullets rewritten for one role", "Exaggerations cut, real numbers added with you", "Keywords tailored to one job type", "Word + PDF delivery"],
  },
  {
    id: "full", lookup: "full_resume", name: "Full Resume", price: 120, featured: true, blurb: "Every role, pointed in one clear direction.",
    items: ["Bullets rewritten for every role", "Exaggerations cut, real numbers added with you", "Keywords tailored to one job type", "Word + PDF delivery"],
  },
  {
    id: "two", lookup: "two_targets", name: "Two Targets", price: 175, blurb: "For when you're applying to two kinds of jobs.",
    items: ["Everything in Full Resume", "A second version tailored to another job type", "Two sets of Word + PDF files"],
  },
];
